import React from 'react';
import moment from 'moment';
import NumericLabel from 'react-pretty-numbers';
import { browserHistory } from 'react-router';
import { TableRow, TableCell, Checkbox, Tooltip, Chip } from '@material-ui/core';
import { invoiceTypes, invoiceStatusDrpdwn, displayDateFormatShort,invoiceStatusList } from '../../../constants';
import { getCurrencyFormat, dateTransform } from '../../../utils_v2';
import { CheckBox, InfoOutlined } from '@material-ui/icons';
import { titanInstance } from '../../../shared_elements/components';
import { jetStreamInstance } from '../../Leases';
const FleetInvoice = ({item, getResponseBack, toggleBulkOps, bulkIds,params,bulkStatus,bulkStatusUpdateIds,invoiceApprovalStatus, pageSelections,currentPage, individualInvoice}) => {
  const isChecked = bulkStatusUpdateIds?.length > 0 ? bulkStatusUpdateIds.find(optionItem => optionItem?.id === item?.id)? true : false:false;
  const itemStatus = item?.invoice_status?.value;
  let overdueDays = '--';

if ([2, 3, 5].includes(item?.invoice_status?.value) && item?.due_date) {
  const diff = (item?.invoice_status?.value === 3 && item?.paid_date ? moment(item.paid_date) : moment()).diff(moment(item.due_date), 'days');
  overdueDays = diff > 0 ? diff : '--';
}

  let assetTypeNames = {
    1: 'aircraft',
    2: 'engine',
    3: 'apu',
    4: 'lg',
    5: 'propeller',
    6: 'fan',
    7: 'hpc',
    8: 'hpt',
    9: 'lpt'
  }
  const redirectUrl = () =>{
    if(item.asset.linked_aircraft_slug){
      window.open(`/aircraft/${item.asset.linked_aircraft_slug}/contract/${item.lease_slug}/invoice/view/${item.id}`,'_blank')
    }else{
      window.open(`/${assetTypeNames[item.asset.asset_type]}/${item.asset.slug}/contract/${item.lease_slug}/invoice/view/${item.id}`,'_blank')
    }
  }
  const hasApprovalFlow = titanInstance &&(item?.invoice_type?.value ===1 || item.is_reserve_releted) && item?.invoice_status?.value === 1 && Object.keys(item?.approval_details)?.length>0 && item?.approval_details?.status ;
  const approvalConfig = {
    approved: {
      label: 'Approved',
      stageLabel: 'Approver',
    },
    pending: {
      label: 'Pending Approval',
      stageLabel: 'Pending Approval Stage',
    },
    reject: {
      label: 'Rejected',
      stageLabel: 'Rejected Stage',
    },
  };
  return(
    <TableRow tabIndex={-1} style={{ cursor: 'pointer' }}>
      {(!jetStreamInstance && !invoiceApprovalStatus) ?
        <TableCell style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1 }} >
          <Checkbox
            size="small"
            disabled={!bulkStatus.includes(item?.invoice_status?.value)}
            checked={isChecked}
            onChange={(e) => { toggleBulkOps(item, e.target.checked, 'single') }}
            name="bulk_operation"
            color="primary"
          />
        </TableCell> : null}
      {jetStreamInstance && individualInvoice? (
        <TableCell style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1 }}>
          <div style={{width:'80px'}}>
          {item.invoice_status.value === 2 ? (
            <Checkbox
              color="primary"
              checked={pageSelections[currentPage]?.includes(item.id) || false}
              onChange={(e) => toggleBulkOps(item, e.target.checked, currentPage)}
            />
          ) : null}
          </div>
        </TableCell>
      ) : null}  
      <TableCell className="asset-info" onClick={() => redirectUrl()}>
          <div className="flex-centered asset-wrapper" style={{flexWrap:"nowrap"}}>
            <div className="assetIcon">
                <img style={{ height: '25px', objectFit: 'contain' }} src={"images/" + (item.asset.asset_type == 1 ? "icon_Aircraft.png" : (item.asset.asset_type == 2) ? "icon_engine.png" : item.asset.asset_type == 3 ? "icon_apu.svg" : item.asset.asset_type == 4 ? 'icon_lg.svg' : item.asset.asset_type == 5 ? 'icon_propeller.svg' : 'icon_engine.png')} alt="img" width="32" />
            </div>
            <div className="asset">
              {
                (item.asset.asset_type === 1 || item.asset.asset_type === 2  || item.asset.asset_type === 3 || item.asset.asset_type === 5) ?
                <p>
                    {item.asset.asset_type === 1 ? item.asset.name ? item.asset.name : item.asset.name : ''}{item.asset.asset_type === 1 ? item.asset.model && ' / ' + item.asset.model: ''}{item.asset.asset_type === 2 ? item.asset.name : ''}{item.asset.asset_type === 3 ? item.asset.name : ''}{item.asset.asset_type === 5 ? item.asset?.model ?item.asset.model: null : null}
                </p> : null
              }
                <h6>{item.asset.unique_name}</h6>
                <p onClick={()=>{window.open(`invoices/summary/${item.summary_invoice_slug}`)}} onMouseEnter={(e) => e.target.style.color = '#6083e2'} onMouseLeave={(e) => e.target.style.color = 'black'} style={{background:'yellow',textDecoration:'underline'}}>{item.summary_invoice_enabled===true?'Linked with summary invoice':''}</p>
                {item.parent?<span style={{fontSize:'14px' ,color:'#6083e2'}}>Parent Invoice:<p onClick={(e)=>{e.preventDefault();e.stopPropagation();window.open(`/${assetTypeNames[item.asset.asset_type]}/${item.asset.slug}/contract/${item.lease_slug}/invoice/view/${item?.parent}/`)}} onMouseEnter={(e) => e.target.style.color = '#6083e2'} onMouseLeave={(e) => e.target.style.color = '4050b5'} style={{textDecoration:'underline', color:'#4050b5', fontSize:'12px', cursor:'pointer'}}>{item?.parent_invoice_number}</p></span>:null}
            </div>
          </div>
      </TableCell>
      <TableCell onClick = {()=>redirectUrl()}>{item.lessor_name && item.lessor_name.name ? item.lessor_name.name:'--'}</TableCell>
      <TableCell onClick = {()=>redirectUrl()}>{item.owner && item.owner.name ? item.owner.name:'--'}</TableCell>
      <TableCell onClick = {()=>redirectUrl()}>
        {item.lessee && item.lessee.logo ? <img style={{width:"60px"}} src={item.lessee && item.lessee.logo} alt="Lessee Logo"/> : <span>{item.lessee && item.lessee.name ? item.lessee.name :'--'}</span>}
      </TableCell>
      <TableCell onClick = {()=>redirectUrl()}>{item.invoice_number}</TableCell>
      <TableCell onClick = {()=>redirectUrl()}>{ item?.is_offset ?
      <><>{item?.invoice_type?.label}</> <>{<Chip
        style={{ marginTop: '8px',fontSize:"10px", fontWeight:'700'}}
        size="small"
        label={'OFFSET'}
        variant='outlined'
        color="primary"/>}</> </>:
      item.invoice_type && item.invoice_type.label ? item.invoice_type.label:'--'}{jetStreamInstance && item?.invoice_type?.value===2 && item?.rental_invoice_type? <span style={{fontSize:'12px',fontWeight:'bold',textTransform:'uppercase',fontFamily:'Conv_IBMPlexSans-Medium'}}> ({item?.rental_invoice_type?.label})</span>:null}</TableCell>
      <TableCell onClick = {()=>redirectUrl()}>
        <p className={item.invoice_status.value && (hasApprovalFlow && item?.approval_details?.status === "approved" ? invoiceStatusList[7] + ' invoice-status' : invoiceStatusList[item.invoice_status.value == 2 && item?.is_offset?1:item.invoice_status.value] + ' invoice-status')}>{
          item?.is_offset ? <>
            <span>
              {item.invoice_status ? [1,2].includes(item.invoice_status.value) ? 'OFFSET' : item.invoice_status.value == 3 ? 'FULLY OFFSET' : item.invoice_status.value == 5 ? 'PARTIALLY OFFSET' : '-- ' : 'OFFSET'}
            </span> </> :
        item.invoice_status && item.invoice_status.label ? hasApprovalFlow && item?.approval_details?.status === "approved" ? "APPROVED" : item.invoice_status.label.toUpperCase():'--'}</p>
        <span className="payment-text">
          { ((item.invoice_status.value == 2) && item.in_due) ?  <span className="invoice-status-payment" >{"Overdue By " + dateTransform(item.due_date)}</span> : ''}
        </span>
        {hasApprovalFlow && approvalConfig[item.approval_details.status] &&  (
          item.approval_details?.status === "reject"? 
          <span className="payment-text">
            {`${approvalConfig[item.approval_details.status].label} (${item?.approval_details?.stage})`}
            <span className="payment-text">
              {approvalConfig[item.approval_details.current_status].stageLabel}:
              <span className="payment-text">{item?.approval_details?.current_stage}</span>
            </span>
          </span> :<span className="payment-text">
            {approvalConfig[item.approval_details.status].label}
            <span className="payment-text">
              {approvalConfig[item.approval_details.status].stageLabel}:
              <span className="payment-text">{item?.approval_details?.stage}</span>
            </span>
          </span>
        )}
        {
          item?.qb_last_sync_time && item?.qb_last_sync_by?.name ?
            <span className="payment-text">Sync Status:
              {item?.qb_last_sync_time ? moment(item?.qb_last_sync_time).format('MMM DD, YYYY') : '--'}{' by '}{item?.qb_last_sync_by?.name || '--'}
              <br /></span>
            : null}
        {
          item.invoice_status.value == 5 && item.partial_paid_date ?
          <span className="payment-text">
            <span>Partial Payment : {item?.partial_paid_amount_curr  ? (item?.currency==='USD'?'US':'').concat(item?.partial_paid_amount_curr) : '--'}<br/></span>
            <span>Payment Date : {moment(item.partial_paid_date).format('MMM DD,YYYY')}<br/></span>
            <span>Balance Amount : {item?.balance_amount_curr  ? (item?.currency==='USD'?'US':'').concat(item?.balance_amount_curr) : '--'}<br/></span>
            {moment(item.partial_paid_date).diff(moment(item.due_date), 'days') > 0 ? <span className="invoice-status-payment">{"Payment late by " + dateTransform(item.due_date)}</span>:''}
          </span> : null
        }
        {
          item.invoice_status.value == 3 && item.paid_date ?
          <span className="payment-text">
            Payment Date: {moment(item.paid_date).format(displayDateFormatShort)}
            {moment(item.paid_date).diff(moment(item.due_date), 'days') > 0 ? <span  className="invoice-status-payment">{"Payment late by " + dateTransform(item.due_date, item.paid_date)}</span> :''}
          </span>:
          null
        }
      </TableCell>
      <TableCell onClick = {()=>redirectUrl()}>{item?.bank_name?item?.bank_name:'--'}</TableCell>
      <TableCell onClick={() => redirectUrl()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <NumericLabel params={getCurrencyFormat({ currency: item.currency, shortFormat: false })}>{item.sub_total}</NumericLabel>
        {item?.excess_amount > 0 ?
          <Tooltip title={`Total Excess Amount:${item?.currency === 'USD' ? 'US$' : item?.currency === 'EUR' ? '€' : ''}${item?.excess_amount}`}>
            <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
          </Tooltip> : null}
        </div>  
      </TableCell>
      <TableCell onClick = {()=>redirectUrl()} style={{textAlign:" -webkit-center",width:"170px"}}>{item.start_date ? item.start_date : '--'} <br/><span>to</span><br/> {item.end_date ? item.end_date : '--'}</TableCell>
      {!jetStreamInstance &&<TableCell onClick = {()=>redirectUrl()}>{item?.paid_date ? moment(item.paid_date).format(displayDateFormatShort) : '--'}</TableCell>}
      <TableCell onClick = {()=>redirectUrl()}>{item.date ? item.date : '--'}</TableCell>
      <TableCell onClick = {()=>redirectUrl()}>{item.due_date ? item.due_date : '--'}</TableCell>
      {!jetStreamInstance &&<TableCell onClick = {()=>redirectUrl()}>{overdueDays}</TableCell>}
    </TableRow>
  )
}
export default FleetInvoice;